import { render, staticRenderFns } from "./Stacked.vue?vue&type=template&id=e10695a2&"
import script from "./Stacked.vue?vue&type=script&lang=js&"
export * from "./Stacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports